import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import AssignmentStatusLegend from '@/modules/Marketing/components/List/LeadFilters/AssignmentStatusLegend'

const AssignmentStatusLegendModal: React.FC<ModalProps> = ({
    onClose,
    open,
}) => {
    const { t } = useTranslation('marketing')

    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={t('assignment_status.legend_title')}
            maxWidth="sm"
        >
            <AssignmentStatusLegend />
        </Dialog>
    )
}

export default AssignmentStatusLegendModal
